<template>
  <div>
    <!-- skにステータスが設定されているときの表示内容 -->
    <div v-if="skProp.recruitment_flow_status" style="display: flex; align-items: center">
      <div style="display: flex; align-items: center">
        <!-- アクションがある時の表示内容 -->
        <template v-if="actionProp">
          <div
            style="
              display: flex;
              align-items: center;
              width: 160px;
              white-space: nowrap;
              overflow: auto;
            "
          >
            <template>
              <span>
              <!-- 実行したアクション名の表示処理 -->
              <p
                v-if="latestName(skProp.recruitment_flow_action_history)"
                @click="openModal"
                style="text-align: left; padding: 2px 4px; cursor: pointer; border-radius: 4px;"
                :style="{'background-color': latestColor(skProp.recruitment_flow_action_history), 'color': textColor(skProp.recruitment_flow_action_history)}"
              >
                <!-- アイコンの表示処理 -->
                <i
                  v-if="latestType(skProp.recruitment_flow_action_history) === 0"
                  class="mdi mdi-email"
                ></i>
                <i
                  v-else-if="latestType(skProp.recruitment_flow_action_history) === 1"
                  class="mdi mdi-email-variant"
                ></i>
                <i
                  v-else-if="latestType(skProp.recruitment_flow_action_history) === 2"
                  class="mdi mdi-phone"
                ></i>
                {{ latestName(skProp.recruitment_flow_action_history) }}
              </p>
              <p v-else>
                <button class="button is-small" @click="openModal">設定する</button>
              </p>
              <!-- アクション種別：SMS時の送付結果表示 -->
              <div v-if="latestResult(skProp.recruitment_flow_action_history) === 'SMS'">
                <p v-if="sms_receive">返信有</p>
                <p v-else>未返信</p>
              </div>
              <!-- アクション種別：Email時の送付結果表示 -->
              <div v-else-if="latestResult(skProp.recruitment_flow_action_history) === 'Email'">
                <!-- Emailアクション：ロボリンク無し -->
                <div v-if="!mail_robo_id">
                  <p v-if="mail_open">開封済</p>
                  <p v-else-if="!mail_open && mail_deliver">未開封</p>
                  <p v-else-if="!mail_deliver">未送信</p>
                </div>
                <!-- Emailアクション：ロボリンクあり -->
                <div v-else>
                  <p v-if="robo_is_goal">回答済</p>
                  <p v-else-if="!robo_is_goal && mail_link">未回答</p>
                  <p v-else-if="!mail_link && mail_open">未リンク</p>
                  <p v-else-if="!mail_open && mail_deliver">未開封</p>
                  <p v-else-if="!mail_deliver">未送信</p>
                </div>
              </div>
              <!-- アクション種別：電話のデータが増えた場合に追加する -->
              <div v-if="latestResult(skProp.recruitment_flow_action_history) === 'Tel'">
              </div>
              </span>
            </template>
          </div>
        </template>
        <!-- アクションがないときの表示内容 -->
        <template v-else>
          <select class="select" disabled>
            <option>-</option>
          </select>
        </template>
        <div
          style="display: flex; margin-left: 16px; padding: 4px"
          class="date-area"
          :class="{
            'is-finished-date': latestIsFinished(skProp.recruitment_flow_action_history),
            'isnt-finished-date':
              !latestIsFinished(skProp.recruitment_flow_action_history) &&
              latestEndedAt(skProp.recruitment_flow_action_history),
          }"
        >
          <!-- 実行日 -->
          <p class="date" style="width: 70px">
            {{ latestEndedAt(skProp.recruitment_flow_action_history) }}
          </p>
          <!-- アクションの実行状況 -->
          <span
            style="margin-left: 4px; color: red; font-weight: bold"
            v-if="latestIsFinished(skProp.recruitment_flow_action_history)"
            >済</span
          >
          <span
            style="margin-left: 4px; color: blue; font-weight: bold"
            v-else-if="latestEndedAt(skProp.recruitment_flow_action_history)"
            >未</span
          >
        </div>
      </div>
      <!-- 履歴 -->
      <div style="margin-left: 16px">
        <a @click="changeOpenLog()" style="text-align: left; font-size: small; white-space: nowrap">
          <span class="mdi mdi-animation-outline" style="margin-right: 4px"></span>履歴
        </a>
      </div>
    </div>
    <!-- skにステータスが設定されていないときの表示内容 -->
    <div v-else style="display: flex">
      <p style="display: flex; min-width: 272px; color: gray; white-space: nowrap">
        ステージ、ステータスを選択してください
      </p>
      <div style="margin-left: 16px">
        <a @click="changeOpenLog()" style="text-align: left; font-size: small; white-space: nowrap">
          <span class="mdi mdi-animation-outline" style="margin-right: 4px"></span>履歴
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActionSet',
  props: ['skProp', 'actionProp'],
  data() {
    return {
      openLog: false,
      mail_deliver: false,
      mail_open: false,
      mail_link: false,
      mail_robo_id: null,
      robo_is_goal: false,
      sms_receive: false,
    }
  },
  methods: {
    openModal() {
      const data = {
        action: this.actionProp,
        sk: this.skProp,
      }
      this.$emit('openActionCheckModal', data)
    },
    changeOpenLog() {
      if (this.skProp.recruitment_flow_action_history.length === 0) {
        alert('アクション履歴がありません。')
      } else {
        this.$emit('openActionTableModal', this.skProp)
      }
    },
    latestEndedAt(histories) {
      if (typeof histories === 'object') {
        if (histories[histories.length - 1]) {
          const date = this.$moment(histories[histories.length - 1].ended_at).format('YYYY/MM/DD')
          if (date === 'Invalid date') {
            return ''
          } else {
            return date
          }
        }
      }
      return ''
    },
    latestName(histories) {
      if (typeof histories === 'object') {
        if (histories[histories.length - 1]) {
          return histories[histories.length - 1].action_data.name
        }
      }
      return ''
    },
    latestColor(histories) {
      if (typeof histories === 'object') {
        if (histories[histories.length - 1]) {
          return histories[histories.length - 1].action_data.color ? histories[histories.length - 1].action_data.color : '#ffffff'
        }
      }
      return '#ffffff'
    },
    latestResult(histories) {
      if (typeof histories === 'object') {
        const last_idx = histories.length - 1
        if (histories[last_idx]){
          if (histories[last_idx].sms_log !== null){
            this.sms_receive = histories[last_idx].sms_log.is_receive
            return 'SMS'
          }
          if (histories[last_idx].email_log !== null){
            this.mail_deliver = histories[last_idx].email_log.is_deliver
            this.mail_open = histories[last_idx].email_log.is_open
            this.mail_link = histories[last_idx].email_log.is_link
            if (histories[last_idx].action_data.chatbots !== null){
              this.mail_robo_id = histories[last_idx].action_data.chatbots
              if(histories[last_idx].email_robo_is_goal === true){
                this.robo_is_goal = true
              }else{
                this.robo_is_goal = false
              }
            }
            return 'Email'
          }
          if (histories[last_idx].action_data.type === 2){
            return 'Tel'
          }
        }
        return ''
      }
      return ''
    },
    latestType(histories) {
      if (typeof histories === 'object') {
        if (histories[histories.length - 1]) {
          return histories[histories.length - 1].action_data.type
        }
      }
      return ''
    },
    latestIsFinished(histories) {
      if (typeof histories === 'object') {
        if (histories[histories.length - 1]) {
          return histories[histories.length - 1].is_finished
        }
      }
      return ''
    },
    textColor(histories) {
      return this.isDark(this.latestColor(histories)) ? '#ffffff' : '#000000';
    },
    isDark(color) {
      const rgb = this.hexToRgb(color);
      const brightness = 0.2126 * rgb.r + 0.7152 * rgb.g + 0.0722 * rgb.b;
      return brightness < 128;
    },
    hexToRgb(hex) {
      let r = 0, g = 0, b = 0;
      if (hex.length === 4) {
        r = parseInt(hex[1] + hex[1], 16);
        g = parseInt(hex[2] + hex[2], 16);
        b = parseInt(hex[3] + hex[3], 16);
      } else if (hex.length === 7) {
        r = parseInt(hex[1] + hex[2], 16);
        g = parseInt(hex[3] + hex[4], 16);
        b = parseInt(hex[5] + hex[6], 16);
      }
      return { r, g, b };
    }
  },
}
</script>

<style scoped>
.date-area {
  width: 96px;
}
.is-finished-date {
  background: lightpink;
}
.isnt-finished-date {
  background: lightblue;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/fields/ActionSet.vue